<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('public.tipTitle')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="1000px"
    append-to-body
  >
    <div class="table-title">{{ $t('enterprise.syncSuccess') }}</div>
    <div class="table-content-text">
      {{ $t('user.updateUserNum') }} {{ tableDataObj.updateList.length }}，
      <span class="view-btn" @click="viewClick('updateListVisible')">
        {{ $t('user.viewSynchroUser') }}
      </span>
    </div>
    <!-- 表格 -->
    <EdmCustomTable
      v-show="updateListVisible"
      ref="EdmCustomTable"
      class="plr8"
      row-key="username"
      :table-data="tableDataObj.updateList"
      :pagination="updatePagination"
      :front-pagination="true"
      @handleSizeChange="
        val => {
          handlePaginationChange(val, 'updatePagination');
        }
      "
      @handleCurrentChange="
        val => {
          handlePaginationChange(val, 'updatePagination');
        }
      "
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.field"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :min-width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row[cm.field] }}
        </template>
      </el-table-column>
    </EdmCustomTable>
    <div class="table-content-text">
      {{ $t('user.saveUserNum') }} {{ tableDataObj.saveList.length }}，
      <span class="view-btn" @click="viewClick('saveListVisible')">
        {{ $t('user.viewSynchroUser') }}
      </span>
    </div>
    <!-- 表格 -->
    <EdmCustomTable
      v-show="saveListVisible"
      ref="EdmCustomTable"
      class="plr8"
      row-key="username"
      :table-data="tableDataObj.saveList"
      :pagination="savePagination"
      :front-pagination="true"
      @handleSizeChange="
        val => {
          handlePaginationChange(val, 'savePagination');
        }
      "
      @handleCurrentChange="
        val => {
          handlePaginationChange(val, 'savePagination');
        }
      "
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.field"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :min-width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row[cm.field] }}
        </template>
      </el-table-column>
    </EdmCustomTable>
    <div class="table-title">{{ $t('user.failSynchro') }}</div>
    <div class="table-content-text">
      {{ $t('user.failedUserNum') }} {{ tableDataObj.failedList.length }}，
      <span class="view-btn" @click="viewClick('failedListVisible')">
        {{ $t('user.viewSynchroUser') }}
      </span>
    </div>
    <EdmCustomTable
      v-show="failedListVisible"
      ref="EdmCustomTable"
      class="plr8"
      row-key="username"
      :table-data="tableDataObj.failedList"
      :pagination="failedPagination"
      :front-pagination="true"
      @handleSizeChange="
        val => {
          handlePaginationChange(val, 'failedPagination');
        }
      "
      @handleCurrentChange="
        val => {
          handlePaginationChange(val, 'failedPagination');
        }
      "
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.field"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :min-width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row[cm.field] }}
        </template>
      </el-table-column>
    </EdmCustomTable>
    <!-- /表格 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">
        {{ $t('common.closeTxt') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "SynchroResult",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      tableColumns: [
        {
          name: this.$t("userCenter.name"),
          field: "displayName",
          width: "100",
          fixed: false
        },
        {
          name: this.$t("public.username"),
          field: "username",
          width: "200",
          fixed: false
        },
        {
          name: this.$t("public.reason"),
          field: "message",
          width: "auto",
          fixed: false
        }
      ],
      updateListVisible: false,
      saveListVisible: false,
      failedListVisible: false,
      updatePagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      savePagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      failedPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableDataObj: {
        saveList: [],
        updateList: [],
        failedList: []
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    if (this.propData) {
      this.tableDataObj = JSON.parse(JSON.stringify(this.propData));
      this.savePagination.total = this.propData.saveList.length;
      this.updatePagination.total = this.propData.updateList.length;
      this.failedPagination.total = this.propData.failedList.length;
    }
  },
  methods: {
    viewClick(name) {
      this[name] = !this[name];
    },
    // 条数改变|页数改变
    handlePaginationChange(data, page) {
      this.$set(this, page, data);
    }
  }
};
</script>

<style scoped lang="scss">
.table-title {
  font-size: 18px;
  line-height: 32px;
}
.view-btn {
  cursor: pointer;
  color: #00b259;
}
.synchro-org {
  float: left;
  line-height: 32px;
}
::v-deep .self-dialog-form {
  .el-dialog__body {
    max-height: 100% !important;
    overflow-y: hidden !important;
  }
}
.plr8 {
  padding: 0 8px;
}
.table-content-text {
  padding: 8px;
}
.mr16 {
  margin-right: 16px;
}
</style>
